/** @file The selection as data indices (unknown ids, e.g. not yet compiled, are skipped). */
import type { SelectionSlice } from '../../stores/types';
import type { SceneMaps } from './scene/sceneMaps';

/** Bones and slots of the selection that exist in the compiled rig. */
export function selectedIndices(maps: SceneMaps, selection: Pick<SelectionSlice, 'bones' | 'slots'>): { bones: number[]; slots: number[] } {
  const of = (ids: readonly string[], index: ReadonlyMap<string, number>): number[] => ids.flatMap((id) => { const i = index.get(id); return i === undefined ? [] : [i]; });
  return { bones: of(selection.bones, maps.boneIndex), slots: of(selection.slots, maps.slotIndex) };
}
